import { z } from 'zod/v4';

export const ExportNetworkRequestSchema = z
  .object({
    ids: z.array(z.string().min(1)).max(500).optional().default([]),
    columnKeys: z.array(z.string()).nullable().optional(),
  })
  .strip();

export type ExportNetworkRequest = z.infer<typeof ExportNetworkRequestSchema>;
